export const setNotificationSetupCookie = () => {
  localStorage.setItem("notification_setup", "1");
  // setCookie("notification_setup", "1", 366);
};
